import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { AlignerComponent } from './aligner/aligner.component'
import { MailHistoryComponent } from './mail-history/mail-history.component'
import { BroadcastMailHistoryComponent } from './broadcast-mail-history/broadcast-mail-history.component'
import { AuditComponent } from './audit/audit.component'
import { ChatHistoryComponent } from './chat-history/chat-history.component'
import { AuthGuard } from '../../../services/guarad/auth.guard'
import { LayoutAppElementComponent } from '../layout_app_element/layout-app-element.component'
import { AvailabilityGuard } from '../../../services/guarad/availability.guard'

const routes: Routes = [
    {
        path: 'app/main/status', canActivate: [AuthGuard, AvailabilityGuard], component: LayoutAppElementComponent,
        children: [
            { path: '', redirectTo: 'aligner', pathMatch: 'full' },
            { path: 'aligner', component: AlignerComponent },
            { path: 'mail', component: MailHistoryComponent },
            { path: 'broadcastmail', component: BroadcastMailHistoryComponent },
            { path: 'chat', component: ChatHistoryComponent },
            { path: 'audit', component: AuditComponent },
            // {path: 'mail-history', component: PromotionComponent, pathMatch: 'full'},
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class StatusRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/status.routing.ts